module.exports = __webpack_public_path__ + "static/media/super_market_9.86d71457.jpg";